<template>
  <div class="foundation">
    <navbar />

    <!-- Playground -->
    <component v-bind:is="currentLevelComponent"></component>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

import {
  VariableOne,
  VariableTwo,
  OperatorOne,
  LoopOne,
  LoopTwo,
  ListOne,
  ConditionalOne,
  ConditionalTwo,
  FunctionOne,
  FunctionTwo,
  FunctionThree
} from "@/components/levels";
import LevelRepository from "@/repositories/level-repository";

export default {
  name: "Foundation",

  components: {
    Navbar,
    VariableOne,
    VariableTwo,
    OperatorOne,
    LoopOne,
    LoopTwo,
    ListOne,
    ConditionalOne,
    ConditionalTwo,
    FunctionOne,
    FunctionTwo,
    FunctionThree
  },

  data() {
    return {
      id: this.$route.params.id,
      levels: []
    };
  },

  created() {
    this.getLevels();
  },

  computed: {
    currentLevelComponent() {
      return this.levels[parseInt(this.id) - 1].name;
    }
  },

  methods: {
    getLevels() {
      this.levels = LevelRepository.getLevels();
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    next();
  }
};
</script>

<style lang="less" scoped></style>
